import { DrawerOverlay } from '@chakra-ui/react';

export const UiDrawerOverlay = DrawerOverlay;
